module.exports = __webpack_public_path__ + "static/media/img9.c1f1d5e5.jpeg";